import { c as _c } from "react/compiler-runtime";
import { Center } from '@chakra-ui/react';
import VideoWalkthroughCard from '@src/components/sco/InvestorMatching/InvestorMatchingLanding/VideoWalkthroughCard';
import { ContentSection } from '@src/components/sco/LayoutBlocks/ContentSection';
import React from 'react';
export const PerfectCustomEmailsContent = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [{
      title: "Generate My Email Pitch",
      href: "/investors/matching/start",
      variant: "cta"
    }];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ContentSection componentPlacement="right" description="Not sure what to write in your emails? Don't worry about it - we do. We'll use your existing assets (pitch deck, notes) to write customized emails based on exactly what our target investor needs to see. You'll be able to provide live-updating feedback and modify messages as needed." title="Customized Investor Pitch Emails" buttons={t0} component={<Center width="full"><VideoWalkthroughCard url="/assets/videos/investor-match/pitch-builder-demo-1080p.mp4" /></Center>} />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};